import React from 'react'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import ImageEditModal from '../../../modules/image/ImageEditModal'
import {
  setProfileImage,
  updateProfileImage,
  addGalleryImage,
  updateGalleryImage,
  addLinkImage,
  updateLinkImage,
} from '../../../actions/portal'
import {
  ADD_GALLERY_IMAGE,
  UPDATE_GALLERY_IMAGE,
  SET_PROFILE_IMAGE,
  UPDATE_PROFILE_IMAGE,
  ADD_LINK_IMAGE,
  UPDATE_LINK_IMAGE,
  UPDATE_LISTING_IMAGE,
  ADD_LISTING_IMAGE,
  ADD_BANNER_IMAGE_ITEM,
  UPDATE_BANNER_IMAGE_ITEM,
  UPDATE_CONTRIBUTOR_IMAGE,
  ADD_CONTRIBUTOR_IMAGE,
} from '../../../constants/actions'
import { addListingImage, updateListingImage } from '../../../actions/listing'
import { addBannerImage, updateBannerImage } from '../../../actions/banners'
import { TOWN_BANNER_ITEM_MODAL } from '../../../constants/modalType'
import {
  updateContributorImage,
  addContributorImage,
} from '../../../actions/contributor'

class ImageEditModalWithRedux extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleUpdatePortal = this.handleUpdatePortal.bind(this)
  }

  async handleUpdatePortal(openParams, closeParams) {
    try {
      console.log('this.props.', this.props)
      console.log('params', openParams, closeParams)
      const originalImageID = _.get(openParams, 'originalImageID')
      const replaceImageID = _.get(openParams, 'replaceImageID')
      const action = _.get(openParams, 'action')
      const croppedImageFile = _.get(closeParams, 'croppedImageFile')

      if (!croppedImageFile) {
        console.log('no cropped image file.')
        return
      }

      switch (action) {
        case SET_PROFILE_IMAGE:
          this.props.actions.setProfileImage(croppedImageFile)
          break
        case UPDATE_PROFILE_IMAGE:
          this.props.actions.updateProfileImage(
            croppedImageFile,
            replaceImageID,
            originalImageID,
          )
          break
        case ADD_GALLERY_IMAGE:
          this.props.actions.addGalleryImage(croppedImageFile)
          break
        case UPDATE_GALLERY_IMAGE:
          this.props.actions.updateGalleryImage(
            { mainImageId: replaceImageID },
            croppedImageFile,
            originalImageID,
          )
          break
        case ADD_LINK_IMAGE:
          this.props.actions.addLinkImage(croppedImageFile)
          break
        case UPDATE_LINK_IMAGE:
          this.props.actions.updateLinkImage(
            { mainImageId: replaceImageID },
            croppedImageFile,
            originalImageID,
          )
          break
        case ADD_LISTING_IMAGE:
          this.props.actions.addListingImage(croppedImageFile)
          break
        case UPDATE_LISTING_IMAGE:
          this.props.actions.updateListingImage(
            croppedImageFile,
            replaceImageID,
            originalImageID,
          )
          break
        case ADD_BANNER_IMAGE_ITEM:
          this.props.actions.addBannerImage(
            _.get(openParams, 'bannerID'),
            croppedImageFile,
          )
          this.props.modalActions.showModal(TOWN_BANNER_ITEM_MODAL, {
            bannerID: _.get(openParams, 'bannerID'),
          })
          break
        case UPDATE_BANNER_IMAGE_ITEM:
          this.props.actions.updateBannerImage(
            _.get(openParams, 'bannerID'),
            croppedImageFile,
            replaceImageID,
            originalImageID,
          )
          this.props.modalActions.showModal(TOWN_BANNER_ITEM_MODAL, {
            bannerID: _.get(openParams, 'bannerID'),
          })
          break
        case UPDATE_CONTRIBUTOR_IMAGE:
          this.props.actions.updateContributorImage(
            croppedImageFile,
            replaceImageID,
            originalImageID,
          )
          break
        case ADD_CONTRIBUTOR_IMAGE:
          this.props.actions.addContributorImage(croppedImageFile)
          break
        default:
          break
      }
    } catch (error) {
      toast.error('ImageEditModalWithRedux : ', error.message)
    }
  }

  async handleClose(closeParams) {
    this.props.modalActions.hideModal(closeParams)

    if (_.get(closeParams, 'croppedImageFile')) {
      this.handleUpdatePortal(this.props.modal.openParams, closeParams)
    }
  }

  render() {
    return (
      <ImageEditModal
        params={this.props.modal.openParams}
        onRequestClose={this.handleClose}
      />
    )
  }
}

ImageEditModalWithRedux.propTypes = {
  ...modalPropTypes,
}

export default compose(
  withReduxModal,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        {
          setProfileImage: setProfileImage,
          updateProfileImage: updateProfileImage,
          addGalleryImage: addGalleryImage,
          updateGalleryImage: updateGalleryImage,
          addLinkImage: addLinkImage,
          updateLinkImage: updateLinkImage,
          addListingImage: addListingImage,
          updateListingImage: updateListingImage,
          addBannerImage: addBannerImage,
          updateBannerImage: updateBannerImage,
          updateContributorImage: updateContributorImage,
          addContributorImage: addContributorImage,
        },
        dispatch,
      ),
    }),
  ),
)(ImageEditModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/image-management/ImageEditModalWithRedux.js